import script from "./DoTheMathQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./DoTheMathQuestion.vue?vue&type=script&setup=true&lang=js"

import "./DoTheMathQuestion.vue?vue&type=style&index=0&id=3e5153b0&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5153b0"]])

export default __exports__